import * as SagaType from '../../constants/constant_saga_types';

const INITIAL_STATE = {
  history: [],
  isFetching: false,
  error: {
    'isError': false,
    'message': null,
  }
};

export default function recordFieldsReducer( state = INITIAL_STATE, action ) {
  switch ( action.type ) {
    case SagaType.FETCHING_RECORD_EXPORT_HISTORY: {
      return {
        ...INITIAL_STATE,
        isFetching: true,
      }
    }

    case SagaType.DONE_FETCH_RECORD_EXPORT_HISTORY: {
      const { history = [] } = action;
      return {
        ...INITIAL_STATE,
        history: [ ...history ]
      }
    }
    default:
      return state;
  }
}